export enum FormInitialisationMode {
    Add = 'Add',
    Edit = 'Edit',
    Delete = 'Delete',
}
